<div class="profile-wrapper">
  <div class="profile-trigger" (click)="toggleProfile()">
    <div class="topnavbar-profile profile-avatar">
      <span *ngIf="firstCharacters">{{ firstCharacters }}</span>
      <mat-icon *ngIf="!firstCharacters" class="icon-avatar" [svgIcon]="'Profile'"></mat-icon>
    </div>

    <p class="profile-name">{{ name }}</p>

    <mat-icon class="profile-chevron" [class.chevron-open]="openProfile"
      [svgIcon]="'Chevron Down'"></mat-icon>
  </div>

  @if (openProfile) {
  <div class="profile-dropdown">
    <button type="button" class="dropdown-item logout" (click)="handleExit()">
      Sair
    </button>
  </div>
  }
</div>
